import React from "react";
import ComingSoon from "@/Utility/ComingSoon/ComingSoon";

const TimeTrackingSettings = () => {
  return (
    <div className="bg-surface-primary border border-border-primary rounded-md shadow-sm p-6">
      <ComingSoon title="Time tracking settings" />
    </div>
  );
};

export default TimeTrackingSettings;
